import {CssBaseline, MetrikaProvider, Notifications, ThemeProvider} from '@logistics-frontend/blocks'
import {ThemeProviderv2} from '@logistics-frontend/blocks/theme'
import {I18nProvider} from '@logistics-frontend/core/i18n'
import {ErrorBoundary, RumObservableRoot} from '@logistics-frontend/modules/rum'
import React from 'react'
import {Provider} from 'react-redux'

import {ErrorNotification} from 'src/pages/route/components/error-notification'
import {config} from 'src/shared/config'

import {i18n} from './i18n'
import {Routes} from './Routes'
import {store} from './store'

export const App: React.FC = () => (
  <ThemeProviderv2 dir={config.dir} locale={config.lang}>
    <ThemeProvider>
      <ErrorBoundary i18n={i18n}>
        <CssBaseline />
        <I18nProvider t={i18n}>
          <Provider store={store}>
            <MetrikaProvider yandexID={config.yaMetrikaID}>
              <RumObservableRoot>
                <Notifications>
                  <Routes />
                  <ErrorNotification />
                </Notifications>
              </RumObservableRoot>
            </MetrikaProvider>
          </Provider>
        </I18nProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </ThemeProviderv2>
)
